import { render, staticRenderFns } from "./temp-refer.vue?vue&type=template&id=73d57df4&scoped=true"
import script from "./temp-refer.vue?vue&type=script&lang=js"
export * from "./temp-refer.vue?vue&type=script&lang=js"
import style0 from "./temp-refer.vue?vue&type=style&index=0&id=73d57df4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d57df4",
  null
  
)

export default component.exports